import { Script } from "components/Script";
import getConfig from "next/config";
import { parseBasicDataToPageData } from "lib/analytics/legacy/datalayer";
import Head from "next/head";
import { connect } from "react-redux";
import { GtmProvider } from "layouts/GtmProvider/GtmProvider";
import { vwoSmartCode } from "./vwoSmartCode";

const { publicRuntimeConfig = {} } = getConfig() || {};

const recaptchaSiteKey = publicRuntimeConfig.PUBLIC_RECAPTCHA_SITE_KEY;

const ThirdPartyScripts = (ctx) => {
    const {
        pageName,
        token,
        cookies,
        tracking: { initialUrl }
    } = ctx;

    const setGoogleTags = () => {
        return `
            window.dataLayer = window.dataLayer || [];
			// temporary before we fully remove automotive context
			window.automotive = window.automotive || [];

            window.initTags = window.initTags || { lastPageView: "", isTagInit: false };

            var pageDataToPush = JSON.parse('${JSON.stringify(
                parseBasicDataToPageData({
                    passedToken: token,
                    cookies,
                    pageName,
                    initialUrl: encodeURIComponent(initialUrl).replace(/'/g, "%27")
                })
            )}');

            if (pageDataToPush && window.initTags.lastPageView !== pageDataToPush.pageType && !window.initTags.isTagInit) {
              window.initTags.isTagInit = true;
            }

            if (pageDataToPush && window.initTags.lastPageView !== pageDataToPush.pageType) {
              window.initTags.lastPageView = pageDataToPush.pageType;
              window.dataLayer.push(pageDataToPush);
            }
          `;
    };
    /*
    const setGTM = () => {
        return `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${GTM_ID}');
          `;
    };

    const setSourcepoint = `
        window._privacy = window._privacy || [];
        window.cmpProperties = {
            baseUrl: 'https://www.autotrack.nl',
            cmpCname: 'https://cmp.autotrack.nl',
            language: 'nl',
            featureFlags: {
              unified: true
            }
        };
        `;
*/
    const pagesWithRecaptcha = [
        "autodetail-overzicht",
        "favorieten",
        "resultaten",
        "autocoach",
        "media"
    ];

    return (
        <>
            {/* <Head>
                <script
                    dangerouslySetInnerHTML={{
                        __html: setGoogleTags()
                    }}
                />
                <Script src="https://i131.autotrack.nl/script.js" />
            </Head>
            <Script id="gtm">{setGTM()}</Script>
            <Script>{setSourcepoint}</Script> */}
            <Script>{vwoSmartCode()}</Script>
            <GtmProvider />
            {pagesWithRecaptcha.includes(pageName) && (
                <Head>
                    <script
                        src={`https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`}
                        async
                    />
                </Head>
            )}
        </>
    );
};

const mapStateToProps = (state) => ({
    token: state.authentication.token,
    cookies: state.cookies.cookies,
    tracking: state.tracking
});

export default connect(mapStateToProps)(ThirdPartyScripts);
